import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {OttopilotEventCudLog} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotEventsWorkspaceCapability/domain/OttopilotEvent";

export enum LogActionType {
    "create" = "ec086646-28ea-4224-b075-9a49be97ad27",
    "delete" = "1d2ceac9-5066-4b8a-9f34-8bb41bbc173d",
    // TODO: Add this
    // "read": "",
    "update" = "18632747-a4cf-4d3c-94c3-31416d4a5e01",
}

export function logActionTypeToDisplayName(logActionType: LogActionType): string {
    switch (logActionType) {
        case LogActionType.create: {
            return "Create";
        }
        case LogActionType.delete: {
            return "Delete";
        }
        case LogActionType.update: {
            return "Update";
        }
        default: {
            console.error("Invalid logActionType", logActionType);
            // throw new Error("Invalid logActionType");
            return "Unknown";
        }
    }
}

export type EventLog = OttopilotEventCudLog;

export type UserLog = {
    id: Uuid;
    actionType: LogActionType;
    actionDetails: Record<string, unknown>;
    userId: Uuid;
    timestamp: Iso8601DateTime;
};
